import { useState, useEffect } from 'react'
import './ToastNotificacao.css'

function ToastNotificacao({ tipo, mensagem, visivel, onFechar }) {
    const [animando, setAnimando] = useState(false)

    useEffect(() => {
        if (visivel) {
            setAnimando(true)
        }
    }, [visivel])

    const handleFechar = () => {
        setAnimando(false)
        setTimeout(() => {
            onFechar && onFechar()
        }, 400)
    }

    if (!visivel) return null

    const icones = {
        sucesso: '🎉',
        motorista: '🚛',
        premium: '🌟',
        avulso: '✅',
        erro: '⚠️'
    }

    const titulos = {
        sucesso: 'Pagamento Confirmado!',
        motorista: 'Motorista Ativado!',
        premium: 'Selo Premium Ativado!',
        avulso: 'Crédito Liberado!',
        erro: 'Processando...'
    }

    const descricoes = {
        sucesso: 'Suas permissões e selos foram ativados com sucesso.',
        motorista: 'Seu pagamento foi confirmado! Agora complete os dados do seu veículo para aparecer na lista de motoristas.',
        premium: 'Seu Selo Premium e seus anúncios ilimitados por 30 dias foram ativados.',
        avulso: 'Seu crédito de anúncio avulso foi liberado. Crie seu anúncio agora!',
        erro: 'O pagamento ainda está sendo processado pelo banco. Seus benefícios entrarão em instantes.'
    }

    return (
        <div className={`toast-overlay ${animando ? 'toast-overlay--ativo' : ''}`} onClick={handleFechar}>
            <div className={`toast-modal ${animando ? 'toast-modal--ativo' : ''}`} onClick={e => e.stopPropagation()}>
                <div className={`toast-icone-wrapper toast-icone--${tipo}`}>
                    <span className="toast-icone">{icones[tipo] || icones.sucesso}</span>
                    <div className="toast-icone-pulse"></div>
                </div>
                
                <h3 className="toast-titulo">{titulos[tipo] || titulos.sucesso}</h3>
                <p className="toast-descricao">{mensagem || descricoes[tipo] || descricoes.sucesso}</p>
                
                <button className="toast-btn" onClick={handleFechar}>
                    Entendido
                </button>
            </div>
        </div>
    )
}

export default ToastNotificacao
